import React from 'react';
import { translate } from 'utlis/translations/i18n';

class InterludePagination extends React.Component {
    render() {
        const { sessionInstance, session, className = '' } = this.props;
        const { currentConclusion } = sessionInstance;
        const { data } = session;
        const { conclusions = [] } = data;

        return (
            <div className={"sequence-pagination-wrapper " + className}>
                <div className="pagination">
                    <span className="muted">{translate('conclusion')}</span> {currentConclusion + 1} <span className="muted">{translate('of')}</span> {conclusions.length}
                </div>
            </div>
        );
    }
}
export default InterludePagination;